// extracted by mini-css-extract-plugin
export default {"header":"CompanySettings_header__4TIRS","textGrid":"CompanySettings_textGrid__oo0OK"};